function updateBorders() {
  const container = document.querySelector('.new-grid');
  if (!container) return;

  const items = Array.from(container.querySelectorAll('.logo-bar__item'));
  if (items.length === 0) return;

  const rowTops = new Map();

  // Reset borders
  items.forEach(item => {
    item.style.borderRight = '1px solid #dbdbdb';
    item.style.borderBottom = '1px solid #dbdbdb';
  });

  // Detect filas por offsetTop
  items.forEach((item) => {
    const top = item.offsetTop;
    if (!rowTops.has(top)) {
      rowTops.set(top, []);
    }
    rowTops.get(top).push(item);
  });

  // Quitar borde derecho al último de cada fila
  rowTops.forEach(rowItems => {
    const lastItem = rowItems[rowItems.length - 1];
    lastItem.style.borderRight = 'none';
  });

  // Quitar borde inferior a los de la última fila
  const allRows = Array.from(rowTops.values());
  const lastRowItems = allRows.pop();

  if (lastRowItems && lastRowItems.length) {
    lastRowItems.forEach(item => {
      item.style.borderBottom = 'none';
    });
  }
}

// Ejecutar al cargar y al redimensionar
window.addEventListener('DOMContentLoaded', updateBorders);
window.addEventListener('resize', updateBorders);

/* Home */
$(document).ready(function(){
  $('#CollectionSection-template--24775760937293__16490846774bd46087 .section-header__link').attr('href','/collections/novedades');
});
/* Fin home */
/* Carruseles */
$(document).ready(function(){
  /* Populares */
  $('#shopify-section-template--24775760937293__featured-collections .new-grid').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /* Populares B2B */
  $('#shopify-section-template--24775760937293__featured_collections_d4tCGW .new-grid').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /* + vendidos */
  $('#CollectionSection-template--24775760937293__1649430755ee5e194e .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  /* + vendidos B2B */
  $('#CollectionSection-template--24775760937293__featured_collection_UVATkU .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  $('#CollectionSection-template--24775760937293__featured-collection .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  $('.distribuidores-container .carousel-track').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true // importante: mantener las flechas en móvil
        }
      }
    ]
  });
});
function toggleSlickCarousel($carousel) {
  if (window.innerWidth <= 768) {
    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots:true
      });
      console.log("✅ Slick inicializado en:", $carousel.attr('class') || $carousel.attr('id'));
    }
  } else {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
      console.log("🔁 Slick destruido en:", $carousel.attr('class') || $carousel.attr('id'));
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const selectors = [
    '.product-recommendations .product-grid',
    '#RecentlyViewed-template--24775761822029__recently-viewed .product-grid'
  ];

  function buscarYActivarCarruseles() {
    selectors.forEach(selector => {
      const $carousel = $(selector);
      if ($carousel.length) {
        toggleSlickCarousel($carousel);
      }
    });
  }

  // Observar el DOM para detectar cuando aparecen los carruseles
  const observer = new MutationObserver(buscarYActivarCarruseles);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Ejecutar al iniciar por si ya están presentes
  buscarYActivarCarruseles();

  // También ejecutar al redimensionar
  window.addEventListener("resize", buscarYActivarCarruseles);
});
/* Fin carruseles */
/* Eliminar botones de add to cart en los upsells */
document.addEventListener("DOMContentLoaded", function () {
  if($('body.template-product').length > 0)
  {
    let intentos = 0;
    const maxIntentos = 20;

    let interval = setInterval(function () {
        intentos++;

        const shadowHost = document.querySelector("#aftersell-pdp-upsell");

        if (!shadowHost) {
            console.log(`❌ [${intentos}] #aftersell-pdp-upsell no encontrado aún.`);
        } else {
            const shadow = shadowHost.shadowRoot;

            if (!shadow) {
                console.log(`⏳ [${intentos}] ShadowRoot aún no disponible.`);
            } else {
                if(jQuery('html[lang="en"]').length > 0)
                {
                  const upsell_title=shadow.querySelector(".upsell-header");
                  jQuery(upsell_title).text('Pairs well with');
                }
              
                const actions = shadow.querySelectorAll(".product-card-actions");

                if (actions.length > 0) {
                    actions.forEach(el => el.remove());
                    console.log(`✅ [${intentos}] Eliminados ${actions.length} elementos '.product-card-actions'.`);
                    clearInterval(interval);
                    return;
                } else {
                    console.log(`🔍 [${intentos}] ShadowRoot listo pero sin '.product-card-actions' todavía...`);
                }
            }
        }

        if (intentos >= maxIntentos) {
            console.warn("⛔ Se alcanzó el número máximo de intentos. Se detiene la comprobación.");
            clearInterval(interval);
        }
    }, 500); // Revisa cada 500ms → 20 intentos = 10 segundos
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if($('body.template-product').length > 0)
  {
    let intentos = 0;
    const maxIntentos = 20;

    let interval = setInterval(function () {
        intentos++;

        const shadowHost = document.querySelector("#aftersell-pdp-upsell");

        if (!shadowHost) {
            console.log(`❌ [${intentos}] #aftersell-pdp-upsell no encontrado aún.`);
        } else {
            const shadow = shadowHost.shadowRoot;

            if (!shadow) {
                console.log(`⏳ [${intentos}] ShadowRoot aún no disponible.`);
            } else {
                const headings = shadow.querySelectorAll("h2, h4");

                if (headings.length > 0) {
                    headings.forEach(heading => {
                        const div = document.createElement("div");
                        div.innerHTML = heading.innerHTML;
                        div.className = heading.className;
                        div.style.cssText = heading.style.cssText;

                        [...heading.attributes].forEach(attr => {
                            if (attr.name !== "class" && attr.name !== "style") {
                                div.setAttribute(attr.name, attr.value);
                            }
                        });

                        heading.replaceWith(div);
                    });

                    console.log(`✅ [${intentos}] Reemplazados ${headings.length} <h2>/<h4> por <div>.`);
                    clearInterval(interval);
                    return;
                } else {
                    console.log(`🔍 [${intentos}] ShadowRoot listo pero sin <h2>/<h4> todavía...`);
                }
            }
        }

        if (intentos >= maxIntentos) {
            console.warn("⛔ Se alcanzó el número máximo de intentos. Se detiene la comprobación.");
            clearInterval(interval);
        }
    }, 500);
  }
});
/* Fin eliminar botones de add to cart en los upsells */
/* Cambios en páginas de colecciones */
$(document).ready(function(){
  if($('#shopify-section-template--24775760413005__faq_M4qz7J').length > 0 && $('.contenido-categ').length > 0)
  {
    var contenido_categ = $('.contenido-categ').last();
    contenido_categ.after($('#shopify-section-template--24775760413005__faq_M4qz7J'));
  }
});

/* Fin cambios en páginas de colecciones */
